import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CodeTypeModel }     from '../core/models/code-type';
import { CompanyService }    from '../companies/company.service';
import { ConfirmService }    from '../messages/confirm/confirm.service';
import { MessagesService }   from '../messages/messages.service';
import { SessionService }    from '../sessions/session.service';
import { UserModel }         from './typings/user';
import { UserPasswordInfo }  from './typings/user.password-info';
import { UsersService }      from './users.service';
import { UserSettingsModel } from './typings/user.settings';
import { XeroService }       from '../xero/xero.service';

@Component({
  selector   : 'wor-user-settings',
  template: require('./user.settings.component.html')
})
export class UserSettingsComponent implements OnInit {
  @Input() jobCardOptions : Array<CodeTypeModel> = [];
  @Input() settings       : UserSettingsModel;
  @Input() user           : UserModel;

  passwordInfo : UserPasswordInfo = {
    confirm_password: '',
    new_password    : '',
    old_password    : ''
  };

  terminals: Array<any> = [];

  constructor (
    public  companyService  : CompanyService,
    private confirmService  : ConfirmService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private sessionService  : SessionService,
    private translateService: TranslateService,
    private usersService    : UsersService,
    public  xeroService     : XeroService
  ) {}

  ngOnInit () : void {
    if ( this.companyService.hasIntegration('celero') ) {
      this.usersService.getTerminals()
      .then(terminals => this.terminals = terminals);
    }

    if ( this.xeroService.wasUserVerificationAttempted() && this.xeroService.didUserVerificationSucceed() ) {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.XERO.USER_VERIFIED'));
    }
    else if ( this.xeroService.wasUserVerificationAttempted() ) {
      this.xeroService.showVerificationError()
      .finally(() => this.router.stateService.go('app.user-settings', {
          code                   : null,
          xero_request_successful: null
        }, {
          inherit: false,
          reload : true
        }));
    }
  }

  changePassword ( form : NgForm ) : void {
    this.usersService.changePassword(this.passwordInfo)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  disconnectXero () : void {
    this.confirmService.generic(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.XERO.CONFIRM_USER_DISCONNECT'))
    .then(() => this.xeroService.disconnectUser(this.user))
    .then(() => {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.XERO.USER_DISCONNECTED'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  hasMultipleCeleroTerminals () : boolean {
    return this.companyService.hasIntegration('celero')
      && !!this.companyService.company.tnp_settings?.tnp_multiple_terminals
      && !!this.terminals.length;
  }

  onSelect ( value : boolean | string, field : string ) : void {
    this.settings[ field ] = value === true || value === 'true'
      ? true
      : value === false || value === 'false'
        ? false
        : null;
  }

  save ( form : NgForm ) : void {
    this.usersService.updateUser(this.settings)
    .then(() => this.sessionService.refresh())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  verifyXero () : void {
    window.location.assign(this.xeroService.getVerifyUserUrl());
  }
}
